<div class="box box-widget widget-user p-4">
  <h4 class="mb-4">Offline Assessment Form</h4>
  <form class="row" [formGroup]="form" (ngSubmit)="onSubmit()">

    <!-- Row 1: Upload Section -->
    <div class="form-group row mb-4">
      <div class="col-md-6">
        <label for="file">File</label>
        <p-fileUpload #fileUpload name="file" customUpload="true" (onSelect)="onFileSelect($event.files)"></p-fileUpload>
        <div *ngIf="submitted && form.controls['file'].invalid" class="text-danger">
          File is required.
        </div>

        <!-- Add New Offline Assessment -->
        <button type="button" class="btn btn-primary mt-2" (click)="addNewOfflineAssessment()">Add New</button>
        <div class="mb-2">
          <small>* Add New Assessment type if it's not available for selection</small>
        </div>
      </div>
    </div>

    <!-- Row 2: Assessment Name, Short Name, and Date -->
    <div class="form-group row mb-4">
      <div class="col-md-4">
        <label for="assessment_name">Assessment Name</label>
        <p-dropdown 
          id="assessment_name" 
          [options]="assessmentNameOptions" 
          formControlName="assessment_name" 
          placeholder="Select an assessment"
          optionLabel="label"
          optionValue="label"
          (onChange)="onAssessmentNameChange()"
          [filter]="true"
          filterPlaceholder="Search">
        </p-dropdown>
        <div *ngIf="submitted && form.controls['assessment_name'].invalid" class="text-danger">
          Assessment Name is required.
        </div>
      </div>

      <div class="col-md-4">
        <label for="assessment_shortname">Assessment Short Name</label>
        <p-dropdown 
          id="assessment_shortname" 
          [options]="assessmentShortNameOptions" 
          formControlName="assessment_shortname" 
          placeholder="Select an assessment"
          (onChange)="onAssessmentShortNameChange()"
          optionValue="label"
          optionLabel="label"
          [filter]="true"
          filterPlaceholder="Search">
        </p-dropdown>
        <div *ngIf="submitted && form.controls['assessment_shortname'].invalid" class="text-danger">
          Assessment Short Name is required.
        </div>
      </div>

      <div class="col-md-4">
        <label for="assessment_date">Assessment Date</label>
        <p-calendar id="assessment_date" formControlName="assessment_date" placeholder="YYYY-MM-DD" appendTo="body"></p-calendar>
        <div *ngIf="submitted && form.controls['assessment_date'].invalid" class="text-danger">
          Assessment Date is required.
        </div>
      </div>
    </div>

    <!-- Recommended By Section -->
    <p class="fw-bold">Recommended By</p>

    <div class="form-group col-md-6">
      <label class="form-label">Department type*</label>
      <p-dropdown
        styleClass="p-dropdown"
        (onChange)="getUserList('recommended')"
        [options]="roleList"
        placeholder="Recommended Type"
        formControlName="recommended_by_role_id"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        filterPlaceholder="Search"
        appendTo="body">
      </p-dropdown>
      <div *ngIf="submitted && form.controls['recommended_by_role_id'].invalid" class="text-danger">
        Department type is required.
      </div>
    </div>

    <div class="form-group col-md-6">
      <label class="form-label">User*</label>
      <p-dropdown
        styleClass="p-dropdown"
        [options]="recommendedByList"
        placeholder="Recommended by"
        formControlName="recommended_by_user_id"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        filterPlaceholder="Search"
        appendTo="body"
        (onChange)="onRecommendedByChange($event.value)">
      </p-dropdown>
      <div *ngIf="submitted && form.controls['recommended_by_user_id'].invalid" class="text-danger">
        User is required.
      </div>
    </div>

    <!-- Conducted By Section -->
    <p class="fw-bold">Conducted By</p>

    <div class="form-group col-md-6">
      <label class="form-label">Department type*</label>
      <p-dropdown
        styleClass="p-dropdown"
        (onChange)="getUserList('conducted')"
        [options]="roleList"
        placeholder="Conducted Type"
        formControlName="conducted_by_role_id"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        filterPlaceholder="Search"
        appendTo="body">
      </p-dropdown>
      <div *ngIf="submitted && form.controls['conducted_by_role_id'].invalid" class="text-danger">
        Department type is required.
      </div>
    </div>

    <div class="form-group col-md-6">
      <label class="form-label">User*</label>
      <p-dropdown
        styleClass="p-dropdown"
        [options]="conductedUserList"
        placeholder="Conducted by"
        formControlName="conducted_by_user_id"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        filterPlaceholder="Search"
        appendTo="body"
        (onChange)="onConductedByChange($event.value)">
      </p-dropdown>
      <div *ngIf="submitted && form.controls['conducted_by_user_id'].invalid" class="text-danger">
        User is required.
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <button type="submit" class="btn btn-primary mt-3">Submit</button>
    </div>
  </form>

  <!-- Dialog for Adding New Assessment -->
  <p-dialog header="Add New Offline Assessment" [(visible)]="displayAddNewOfflineAssessment" [closable]="true" [modal]="true" [responsive]="true" [style]="{width: '50vw'}">
    <form [formGroup]="addAssessmenCatalogForm" (ngSubmit)="onSubmitSaveAssessmentCatalog()">
      <div class="form-group mb-4">
        <label for="assessment_name" class="form-label required">Assessment name</label>
        <input type="text" pInputText id="assessment_name" formControlName="assessment_name" />
        <div *ngIf="submitted1 && addAssessmenCatalogForm.controls['assessment_name'].invalid" class="text-danger">
          Assessment name is required.
        </div>
      </div>

      <div class="form-group mb-4">
        <label for="assessment_shortname" class="form-label required">Assessment short name</label>
        <input type="text" pInputText id="assessment_shortname" formControlName="assessment_shortname" />
        <div *ngIf="submitted1 && addAssessmenCatalogForm.controls['assessment_shortname'].invalid" class="text-danger">
          Assessment short name is required.
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </p-dialog>
</div>
